import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { Routes } from "@/constants/Routes";
import { 
  NavigationDrawer,
  NavigationDrawerItem,
  NavigationRail,
} from "@/components/DesignSystem";
import { Box, Divider, Typography } from '@mui/material';
import { useMediaQuery } from '@/hooks/useMediaQuery';
import { ContentRenderingProps } from "@/components/DesignSystem/NavigationRail/NavigationRail";
import Home from '@mui/icons-material/Home';
import Storefront from '@mui/icons-material/Storefront';
import RequestPage from '@mui/icons-material/RequestPage';
import Person from '@mui/icons-material/Person';

export interface UIShellDemoProps { 
  showDemo?: boolean,
}

export const UIShellDemo = ({ showDemo = false }: UIShellDemoProps) => {

  const { isMobile } = useMediaQuery();
  const [selectedIndex, setSelectedIndex] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    if (!showDemo) {
      navigate(Routes.UI_SHELL_DEMO);
    }
  }, []);

  const selectAction = (index: number, closeDrawer: () => void) => {
    setSelectedIndex(index);
    closeDrawer();
  };

  const actions = (contentRenderingProps: ContentRenderingProps) => [
    <NavigationDrawerItem 
      collapsed={!contentRenderingProps.open} 
      icon={(props) => <Home {...props} /> } 
      isTransitioning={contentRenderingProps.isTransitioning}
      key="option-1"
      onClick={() => selectAction(0, contentRenderingProps.closeDrawer)}
      selected={selectedIndex === 0}
      testID="option-1" 
      text="Home" />,
    <NavigationDrawerItem 
      collapsed={!contentRenderingProps.open} 
      icon={(props) => <RequestPage {...props} /> }
      isTransitioning={contentRenderingProps.isTransitioning}
      key="option-2"
      onClick={() => selectAction(1, contentRenderingProps.closeDrawer)}
      secondaryText='3'
      selected={selectedIndex === 1}
      testID="option-2"
      text="Product Requests" />,
    <NavigationDrawerItem 
      collapsed={!contentRenderingProps.open}
      icon={(props) => <Storefront {...props} /> }
      isTransitioning={contentRenderingProps.isTransitioning}
      key="option-3"
      onClick={() => selectAction(2, contentRenderingProps.closeDrawer)}
      selected={selectedIndex === 2}
      testID="option-3"
      text="Retailers" />,
    <NavigationDrawerItem 
      collapsed={!contentRenderingProps.open}
      icon={(props) => <Person {...props} /> }
      isTransitioning={contentRenderingProps.isTransitioning}
      key="option-4"
      onClick={() => selectAction(3, contentRenderingProps.closeDrawer)}
      selected={selectedIndex === 3}
      testID="option-4"
      text="My Account" />,
    contentRenderingProps.open && (
      <Divider key="divider" sx={{ margin: "8px 12px 8px 12px" }} />
    ),
    (!contentRenderingProps.open && !isMobile) && (
      <Box key="spacer" sx={{ height: "calc(100vh - 408px)" }} />
    ),
    !(!contentRenderingProps.open && isMobile) && (
      <NavigationDrawerItem 
        collapsed={!contentRenderingProps.open} 
        isTransitioning={contentRenderingProps.isTransitioning}
        key="option-5"
        onClick={() => alert("Logout here!")}
        selected={false}
        testID="option-5" 
        text="Logout" />
    ),
  ];

  return (
    <>
      <NavigationRail 
        content={(renderingProps) => (
          <NavigationDrawer 
            collapsed={!renderingProps.open}
            isTransitioning={renderingProps.isTransitioning}
            testID="testID">
            {actions(renderingProps)}
          </NavigationDrawer>
        )}
        testID="navigation-rail"
      >
        <Typography paragraph>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
          tempor incididunt ut labore et dolore magna aliqua. Rhoncus dolor purus non
          enim praesent elementum facilisis leo vel. Risus at ultrices mi tempus
          imperdiet. Semper risus in hendrerit gravida rutrum quisque non tellus.
          Convallis convallis tellus id interdum velit laoreet id donec ultrices.
          Odio morbi quis commodo odio aenean sed adipiscing. Amet nisl suscipit
          adipiscing bibendum est ultricies integer quis. Cursus euismod quis viverra
          nibh cras. Metus vulputate eu scelerisque felis imperdiet proin fermentum
          leo. Mauris commodo quis imperdiet massa tincidunt. Cras tincidunt lobortis
          feugiat vivamus at augue. At augue eget arcu dictum varius duis at
          consectetur lorem. Velit sed ullamcorper morbi tincidunt. Lorem donec massa
          sapien faucibus et molestie ac.
        </Typography>
        <Typography paragraph>
          Consequat mauris nunc congue nisi vitae suscipit. Fringilla est ullamcorper
          eget nulla facilisi etiam dignissim diam. Pulvinar elementum integer enim
          neque volutpat ac tincidunt. Ornare suspendisse sed nisi lacus sed viverra
          tellus. Purus sit amet volutpat consequat mauris. Elementum eu facilisis
          sed odio morbi. Euismod lacinia at quis risus sed vulputate odio. Morbi
          tincidunt ornare massa eget egestas purus viverra accumsan in. In hendrerit
          gravida rutrum quisque non tellus orci ac. Pellentesque nec nam aliquam sem
          et tortor. Habitant morbi tristique senectus et. Adipiscing elit duis
          tristique sollicitudin nibh sit. Ornare aenean euismod elementum nisi quis
          eleifend. Commodo viverra maecenas accumsan lacus vel facilisis. Nulla
          posuere sollicitudin aliquam ultrices sagittis orci a.
        </Typography>
        <Typography paragraph>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
          tempor incididunt ut labore et dolore magna aliqua. Rhoncus dolor purus non
          enim praesent elementum facilisis leo vel. Risus at ultrices mi tempus
          imperdiet. Semper risus in hendrerit gravida rutrum quisque non tellus.
          Convallis convallis tellus id interdum velit laoreet id donec ultrices.
          Odio morbi quis commodo odio aenean sed adipiscing. Amet nisl suscipit
          adipiscing bibendum est ultricies integer quis. Cursus euismod quis viverra
          nibh cras. Metus vulputate eu scelerisque felis imperdiet proin fermentum
          leo. Mauris commodo quis imperdiet massa tincidunt. Cras tincidunt lobortis
          feugiat vivamus at augue. At augue eget arcu dictum varius duis at
          consectetur lorem. Velit sed ullamcorper morbi tincidunt. Lorem donec massa
          sapien faucibus et molestie ac.
        </Typography>
        <Typography paragraph>
          Consequat mauris nunc congue nisi vitae suscipit. Fringilla est ullamcorper
          eget nulla facilisi etiam dignissim diam. Pulvinar elementum integer enim
          neque volutpat ac tincidunt. Ornare suspendisse sed nisi lacus sed viverra
          tellus. Purus sit amet volutpat consequat mauris. Elementum eu facilisis
          sed odio morbi. Euismod lacinia at quis risus sed vulputate odio. Morbi
          tincidunt ornare massa eget egestas purus viverra accumsan in. In hendrerit
          gravida rutrum quisque non tellus orci ac. Pellentesque nec nam aliquam sem
          et tortor. Habitant morbi tristique senectus et. Adipiscing elit duis
          tristique sollicitudin nibh sit. Ornare aenean euismod elementum nisi quis
          eleifend. Commodo viverra maecenas accumsan lacus vel facilisis. Nulla
          posuere sollicitudin aliquam ultrices sagittis orci a.
        </Typography>
        <Typography paragraph>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
          tempor incididunt ut labore et dolore magna aliqua. Rhoncus dolor purus non
          enim praesent elementum facilisis leo vel. Risus at ultrices mi tempus
          imperdiet. Semper risus in hendrerit gravida rutrum quisque non tellus.
          Convallis convallis tellus id interdum velit laoreet id donec ultrices.
          Odio morbi quis commodo odio aenean sed adipiscing. Amet nisl suscipit
          adipiscing bibendum est ultricies integer quis. Cursus euismod quis viverra
          nibh cras. Metus vulputate eu scelerisque felis imperdiet proin fermentum
          leo. Mauris commodo quis imperdiet massa tincidunt. Cras tincidunt lobortis
          feugiat vivamus at augue. At augue eget arcu dictum varius duis at
          consectetur lorem. Velit sed ullamcorper morbi tincidunt. Lorem donec massa
          sapien faucibus et molestie ac.
        </Typography>
        <Typography paragraph>
          Consequat mauris nunc congue nisi vitae suscipit. Fringilla est ullamcorper
          eget nulla facilisi etiam dignissim diam. Pulvinar elementum integer enim
          neque volutpat ac tincidunt. Ornare suspendisse sed nisi lacus sed viverra
          tellus. Purus sit amet volutpat consequat mauris. Elementum eu facilisis
          sed odio morbi. Euismod lacinia at quis risus sed vulputate odio. Morbi
          tincidunt ornare massa eget egestas purus viverra accumsan in. In hendrerit
          gravida rutrum quisque non tellus orci ac. Pellentesque nec nam aliquam sem
          et tortor. Habitant morbi tristique senectus et. Adipiscing elit duis
          tristique sollicitudin nibh sit. Ornare aenean euismod elementum nisi quis
          eleifend. Commodo viverra maecenas accumsan lacus vel facilisis. Nulla
          posuere sollicitudin aliquam ultrices sagittis orci a.
        </Typography>
      </NavigationRail>
    </>
  );
};
